module.exports = __webpack_public_path__ + "static/media/Artboard5.05e878f5.png";